<div class="toggle-group" [class.disabled]="isDisabled">
  <label [for]="toggleId" class="toggle-label">
    <span class="label-text">{{ label }}</span>
    <ng-content></ng-content>
  </label>
  <nz-switch [(ngModel)]="isActive" (click)="toggleActive()" [nzDisabled]="isDisabled" [nzControl]="true"
             class="switch"></nz-switch>
</div>
